import React from 'react';
import AddUserIcon from '@/components/icons/AddUser';
import { CustomButtonProps } from '@/components/Button';
import BlueButtonWithIcon from '@/components/BlueButtonWithIcon';
import t from '@/utils/translate';

export default (props: CustomButtonProps) => {
  return (
    <BlueButtonWithIcon
      {...props}
      icon={<AddUserIcon style={props.disabled ? { color: 'rgba(0, 0, 0, 0.26)' } : {}}/>}
    >
        {t('project.action.invite')}
    </BlueButtonWithIcon>
  );
}
